import {observer} from "mobx-react-lite";
import { SearchResultView } from "../views/searchResultView.jsx";
import { NavBar } from "./navBarPresenter.jsx";
import { SearchBarView } from "../views/searchBarView.jsx";
import "/src/style.css"

const Search = observer(   
    
    function SearchRender(props){
        
        function processResult(searchResultsPromiseState){
            if(!searchResultsPromiseState.promise)
                return <div class="horizontal-align align-center content-center"> <p className="text-colo text-color text-font ">No Data</p></div>
            else if(!searchResultsPromiseState.data && !searchResultsPromiseState.error)
                return <div><div class="horizontal-align align-center content-center">  <img src="https://i.gifer.com/3k2Z.gif" width="300" height="300"/></div><div class="horizontal-align align-center content-center">  <p className="text-color text-font">loading the magic....</p></div></div>
            else if(searchResultsPromiseState.error)
                return searchResultsPromiseState.error;
            else if(props.model.searchResultsPromiseState.data.length == 0){
                return <div class="horizontal-align align-center content-center"> <p className="text-color text-font">"There's no search result. Try to change the search text or filter, or search in other pages."</p></div>
            }
            else{
                console.log(props.model.searchResultsPromiseState.data);
                //console.log([...new Set(searchResultsPromiseState.data.map(d => d.inventors).flat().map(d => `${d?.firstName} ${d?.lastName}`))])
                //console.log([...new Set(searchResultsPromiseState.data.map(d => d.manufacturer))])
                return <SearchResultView page = {props.model.page}
                searchResults={props.model.searchResultsPromiseState.data || []}
                goToDetailHandler = {goToDetailHandler} /> 
            }
                 
        }

        if(props.model.page == 'Houses'){
            return <div> 
            <NavBar model={props.model}/>
            {processResult(props.model.searchResultsPromiseState)}
        
        </div>
        }

        else{   
            return <div> 
                <NavBar model={props.model}/>
                <SearchBarView text = {props.model.searchText}
                                filter = {props.model.searchFilter}
                                page = {props.model.page}
                                onTextChange = {textChangeHandler}
                                onSearchClick = {searchHandler}
                                onFilterChange = {filterChangeHandler}
                                onFilterDelete = {filterDeleteHandler}
                                onClearClick = {clearHandler}
                                flag= {props.model.changeFlag}/> 
                {processResult(props.model.searchResultsPromiseState)}
            </div> }
    function textChangeHandler(name){
        props.model.setSearchText(name)
    }
    function searchHandler(){
        props.model.doSearch()
    }
    function filterChangeHandler(type, option){
        props.model.setSearchFilter(type, option)
    }
    function filterDeleteHandler(type){
        props.model.deleteSearchFilter(type)
    }
    function clearHandler(){
        props.model.clearSearchFilter();
        props.model.deleteSearchText();
        searchHandler();
    }
    function goToDetailHandler(id){
        props.model.setDetail(id)
    }
}

);
    
export { Search };